<template>
  <section>
    <notifications></notifications>

    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteMany(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/vehicles/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Vehicle</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-car"></i>
                    <strong>Category</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    :class="category === 'standard' ? 'active' : ''"
                    @click="typeSearch('standard')"
                  >
                    <i class="flaticon-dry-clean color-standard mr-2"></i>
                    Standard
                  </div>
                  <div
                    class="dropdown-item"
                    :class="category === 'business' ? 'active' : ''"
                    @click="typeSearch('business')"
                  >
                    <i class="flaticon-dry-clean color-business mr-2"></i>
                    Business
                  </div>
                  <div
                    class="dropdown-item"
                    :class="category === 'luxury' ? 'active' : ''"
                    @click="typeSearch('luxury')"
                  >
                    <i class="flaticon-dry-clean color-luxury mr-2"></i>
                    Luxury
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class=""
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-1"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="vehicles.pages"
            v-model="currentPage"
            :total="vehicles.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="vehicles.docs"
            :fields="fields"
            sort-by.sync="category"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length === documents.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #cell(vehicle)="data">
              <router-link
                :to="`/vehicles/${data.item._id}`"
                class="box-img-card"
              >
                <div class="img-car">
                  <LazyImage
                    :src="data.item.information.image"
                    imgClasses="img-fluid es-img-service-2"
                    beforeClasses="img-car"
                    @click="openBox(data.index)"
                  />
                </div>

                <div class="content ">
                  <span class="capitalize hide-data title">
                    {{ showType(data.item.parameters.type) }}
                  </span>

                  <span class="hide-data subtitle-1">{{
                    data.item.parameters.name
                  }}</span>
                </div>
              </router-link>
            </template>

            <template #cell(category)="data">
              <span class="hide-data">{{
                data.item.parameters.category | typeCategory
              }}</span>
            </template>

            <template #cell(seats)="data">
              <span class="hide-data">{{ data.item.parameters.n_seats }}</span>
            </template>

            <template #cell(suitcases)="data">
              <span class="hide-data">{{
                data.item.parameters.n_suitcases
              }}</span>
            </template>

            <template #cell(license)="data">
              <span class="hide-data">{{ data.item.information.licence }}</span>
            </template>

            <template #cell(branch)="data">
              <span
                class="capitalize"
                v-if="data.item.parameters.branch !== null"
                >{{ data.item.parameters.branch.name }}</span
              >
            </template>

            <template #cell(status)="data">
              <div
                class="badge-status badge-success"
                v-if="data.item.owner.active"
              >
                <span>Active</span>
              </div>

              <div class="badge-status badge-danger" v-else>
                <span>Inactive</span>
              </div>
            </template>

            <template #cell(actions)="data">
              <el-tooltip content="Edit" placement="bottom">
                <router-link
                  class="icon-action text-blue"
                  :to="`/vehicles/${data.item._id}`"
                >
                  <i class="flaticon-pencil text-primary"></i>
                </router-link>
              </el-tooltip>

              <el-tooltip
                v-if="data.item.owner.active"
                content="Deactivate"
                placement="bottom"
              >
                <span
                  class="icon-action text-info ml-2"
                  @click.stop="changeStatus(data.item._id, false)"
                >
                  <i class="flaticon-right-4"></i>
                </span>
              </el-tooltip>

              <el-tooltip v-else content="Activate" placement="bottom">
                <span
                  class="icon-action text-info ml-2"
                  @click.stop="changeStatus(data.item._id, true)"
                >
                  <i class="flaticon-right-4"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Delete" placement="bottom">
                <span
                  class="icon-action text-danger ml-2"
                  @click.stop="deleteVehicle(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>

          <pagination-block
            :pageCount="vehicles.pages"
            v-model="currentPage"
            :total="vehicles.count"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import localHelper from "../Commons/Helper";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";

export default {
  name: "Vehicles",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      selectedRows: [],
      currentPage: 1,
      filtered_options: null,
      indexChange: 0,
      makes: [],
      models: [],
      vehicleTypes: [
        { label: "Boats", value: "boat" },
        { label: "Coach", value: "coach" },
        { label: "Limousine", value: "limousine" },
        { label: "Minibus", value: "minibus" },
        { label: "MidiCoach", value: "midicoach" },
        { label: "Minivan", value: "minivan" },
        { label: "MPV", value: "mpv" },
        { label: "Pickup", value: "pickup" },
        { label: "Premium Sedans", value: "premium_sedans" },
        { label: "SUVs", value: "suvs" },
        { label: "Sedan", value: "sedan" }
      ],

      options: [],
      loading: false,
      docs: [],
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "vehicle",
          label: "Vehicle",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },

        {
          key: "category",
          label: "Category",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "text-left"
        },

        {
          key: "seats",
          label: "Seats",
          sortable: true,
          thStyle: { minWidth: "50px" },
          class: "alinmov6"
        },

        {
          key: "suitcases",
          label: "Suitcases",
          sortable: true,
          thStyle: { minWidth: "50px" },
          class: "alinmov6"
        },

        {
          key: "license",
          label: "License Plate",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },

        {
          key: "branch",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "text-left"
        },

        {
          key: "status",
          label: "status",
          sortable: true,
          thStyle: { minWidth: "50px" },
          class: "alinmov6"
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      view: "table",
      selected: [],
      currentBranch: null,
      limit: 0,
      simpleSearch: "",
      category: "",
      query: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        { value: "name", text: "Vehicle" },
        { value: "created_at", text: "Created At" }
      ],
      carsOptions: [],
      visibleSideBar: false,
      guides: [],
      loader: false
    };
  },
  watch: {},
  async created() {
    this.carsOptions = await this.getCarsOptions();
    this.makes = this.carsOptions
      .filter((value, index, self) => {
        return self.map(e => e.make).indexOf(value.make) === index;
      })
      .map(element => {
        return {
          label: element.make_label,
          value: element.make,
          type: element.type
        };
      });
    this.models = this.carsOptions.map(element => {
      return {
        label: element.model_label,
        value: element.model,
        type: element.type,
        make: element.make
      };
    });
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.query = this.vehiclesSearchCriteria.query;
    this.currentPage = this.vehiclesSearchCriteria.currentPage;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
    this.getBranchesOptions();
  },
  async mounted() {
    var bread = [
      {
        text: "Vehicles",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  methods: {
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value);
      } else {
        searchParams.append(key, value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deleteVehicle(vehicleId) {
      let { value } = await Swal.fire({
        title: "Delete Vehicle",
        text: "Are you sure do you want to delete this Vehicle Type?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteVehicleById(vehicleId);
      }
    },
    async deleteVehicleById(vehicleId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.vehicles.services.deleteVehicleById(
          vehicleId,
          this.sesion.token
        );
        this.setLoad(false);
        let result = data.data;
        if (result.deleted) {
          this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Vehicle Type has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          if (!result.actions.verify_rates) {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "This vehicle is assigned a rate, Please unlink the vehicles from the rate.",
              icon: "flaticon-remove"
            });
          }
          if (!result.actions.verify_reservations) {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "This vehicle is assigned a reservation, Please unlink the vehicles from the reservation.",
              icon: "flaticon-remove"
            });
          }
          if (!result.actions.verify_drivers) {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "This vehicle is assigned a driver, Please unlink the vehicles from the driver.",
              icon: "flaticon-066-remove"
            });
          }
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteMany(vehicles = []) {
      let { value } = await Swal.fire({
        title: "Delete vehicles",
        text: "Are you sure do you want to delete the selected Vehicles?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyVehiclesById(vehicles);
      }
    },
    async deleteManyVehiclesById(vehicles = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.vehicles.services.deleteManyVehiclesById(
          vehicles.map(element => element._id),
          this.sesion.token
        );
        this.setLoad(false);
        let result = data.data;
        if (result.deleted) {
          this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Vehicle has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          if (!result.actions.verify_drivers) {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "This vehicle is assigned a driver, Please unlink the vehicles from the driver.",
              icon: "flaticon-066-remove"
            });
          }
          if (!result.actions.verify_rates) {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "This vehicle is assigned a rate, Please unlink the vehicles from the rates.",
              icon: "flaticon-remove"
            });
          }
          if (!result.actions.verify_reservations) {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "This vehicle is assigned a reservation, Please unlink the vehicles from the reservation.",
              icon: "flaticon-remove"
            });
          }
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(vehicles = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.vehicles.services.downloadCVS(
          { vehicles: vehicles },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `vehicles-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async changeStatusById(vehicleId, vehicleStatus) {
      try {
        let {
          status,
          disabled,
          enabled,
          error
        } = await this.changeStatusVehicle(vehicleId, {
          "owner.active": vehicleStatus
        });
        if (status) {
          this.get(false, this.limit, this.currentPage, this.query);
          if (disabled) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "This vehicle has been disabled",
              icon: "flaticon-check-3"
            });
          } else if (enabled) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "This vehicle has been enabled",
              icon: "flaticon-check-3"
            });
          } else if (assigned) {
            this.$notify({
              type: "warning",
              title: "Warning!",
              message:
                "This vehicle is assigned to a rate and can't be deactivated, make sure this vehicle is not assigned to any rate",
              icon: "flaticon-warning-1"
            });
          }
        } else {
          this.handleError(
            error,
            "The Operation could not be completed. Please try again"
          );
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async changeStatus(vehicleId, vehicleStatus) {
      let { value } = await Swal.fire({
        title: "Change status",
        text: `Are you sure do you want change status the selected vehicle?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.changeStatusById(vehicleId, vehicleStatus);
      }
    },
    async changeStatusVehicle(vehicleId, body) {
      try {
        let { data } = await endpoint.vehicles.services.updateAnyAttributeById(
          vehicleId,
          body,
          this.sesion.token
        );
        if (data.status) {
          let result = data.data;
          if (result.updated) {
            return {
              status: true,
              error: null,
              enabled: !result.active ? false : true,
              disabled: !result.active ? true : false,
              assigned: false
            };
          } else {
            return {
              status: true,
              error: null,
              enabled: false,
              disabled: false,
              assigned: true
            };
          }
        } else {
          return {
            status: true,
            error: null,
            enabled: false,
            disabled: false,
            assigned: false
          };
        }
      } catch (error) {
        return {
          status: false,
          error: error,
          enabled: false,
          disabled: false,
          assigned: false
        };
      }
    },
    applySimpleSearch(value) {
      if (value) {
        this.query = this.addElementInQuery(this.query, "search", value);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.deleteItemInQuery(this.query, ["search"]);
        this.get(true, this.limit, 1, this.query);
      }
    },
    typeSearch(category) {
      this.category = category;
      if (category !== "all") {
        this.query = this.addElementInQuery(this.query, "category", category);
        this.get(true, this.limit, 1, this.query);
      } else {
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.cardview === true) {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async get(loader, limit, page, query) {
      this.setVehiclesSearchCriteri({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getVehicles({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.category = searchCriteria.has("category")
        ? searchCriteria.get("category")
        : "";
    },
    async getCarsOptions() {
      try {
        let { data } = await endpoint.vehicles.services.getCarsOptions(
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    showType(type) {
      let car = this.vehicleTypes.find(element => element.value === type);
      return car ? car.label : "";
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("SUPPLIERS", "VEHICLES");
      this.loader = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await endpoint.documents.services.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setVehiclesSearchCriteri"
    ]),
    ...mapActions([
      "getBranchesOptions",
      "getSearchOperators",
      "getVehicles",
      "getSearchVehicles",
      "getLimit"
    ])
  },
  computed: {
    documents: function() {
      if (this.vehicles.docs) {
        return this.vehicles.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "branchesOptions",
      "operatorResponse",
      "vehicles",
      "sesion",
      "sigout",
      "paginationLimit",
      "vehiclesSearchCriteria"
    ])
  },
  filters: {
    typeCategory: function(type) {
      if (type === "business") {
        return "Business Class";
      } else if (type === "luxury") {
        return "Luxury Class";
      } else {
        return "Standard Class";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInVehiclesModule(
      to.meta.modules,
      this.setVehiclesSearchCriteri,
      "vehicles"
    );
    next();
  }
};
</script>
